var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-child"},[(typeof _vm.content === 'string')?_c('div',{staticClass:"event-content",domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('Content',{staticClass:"event-content",attrs:{"content":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }